import axios from "axios";
import qs from "qs";
import { apiBaseUrl } from "@utils/baseValues";

export const axiosService = axios.create({
  baseURL: `${apiBaseUrl}`,
  withCredentials: true,
});

axiosService.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const { response } = error;
    if (
      response &&
      response.status === 401 &&
      window.location.pathname !== "/login" &&
      !error.config.__isRetryRequest
    ) {
      error.config.__isRetryRequest = true;
      axiosService.post("/users/logout");
      window.location.pathname = "/login";
    }
    return Promise.reject(error);
  }
);

export const axiosFormClient = axios.create({
  baseURL: `${apiBaseUrl}`,
  withCredentials: true,
  transformRequest: [(data) => qs.stringify(data)],
});

axiosFormClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const { response } = error;
    if (response && response.status === 401) {
      window.location.href = "/app/select-workspace";
    }
    return Promise.reject(error);
  }
);
